import { get } from "./get-situation"

export const students = {
  get,
}
